import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import WorkflowCanvas from './components/WorkflowCanvas';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Redirect root to canvas (dispatcher) */}
          <Route path="/" element={<Navigate to="/canvas" replace />} />
          
          {/* Canvas/Dispatcher route - Protected */}
          <Route path="/canvas" element={
            <ProtectedRoute>
              <WorkflowCanvas />
            </ProtectedRoute>
          } />
          
          {/* Catch all - redirect to canvas */}
          <Route path="*" element={<Navigate to="/canvas" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;